var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchResults = function SvgSearchResults(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1043 56.1847L71.9984 62.9992C73.1693 64.0093 73.3377 65.8253 72.3762 67.0545C71.4147 68.2838 69.6864 68.4625 68.5164 67.4523L60.6223 60.6369M59.0492 62.6488L65.6774 54.1733M62.3636 58.411L59.1268 55.617M54.5029 56.3727V70.1337C54.5029 71.1649 53.7081 72 52.7265 72H28.7763C27.7948 72 27 71.1649 27 70.1337V29.8672C27 28.836 27.7948 28 28.7763 28H52.7265C53.7081 28 54.5029 28.836 54.5029 29.8672V31.8399M41.2779 39.6404H50.0191M38.72 44.1946H52.2572M38.1866 48.7488H52.2569M40.5323 53.303H49.2727M55.8737 38.3983C60.3957 42.3024 61.0501 49.3186 57.3342 54.0697C53.6184 58.8217 46.9405 59.5082 42.4185 55.6051C37.8965 51.701 37.2421 44.6848 40.9571 39.9337C44.6729 35.1817 51.3508 34.4952 55.8737 38.3983Z",
    stroke: "#000000",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchResults, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-results.dfa87ee7.svg";
export { ForwardRef as ReactComponent };